import { useIntl } from 'react-intl'
import RateCircle from '../../../dashboard/component/components/semiCircle'
import { chartOptions } from '../enums/chartEnums'
import { OverlayTrigger, Spinner, Tooltip } from 'react-bootstrap'

export default function RateAnalytics({
  rate,
}: {
  rate?: {
    analyticsRateDetails: string[]
    participationRate: number
    redemptionRate: number
  }
}) {
  const intl = useIntl()

  const chartInfos = [
    {
      title: intl.formatMessage({ id: 'DASHBOARD.REDEMPTION_RATE' }),
      tooltip: intl.formatMessage({ id: 'DASHBOARD.REDEMPTION_RATE_TOOLTIP' }),
      chartOptions,
      val: [rate?.redemptionRate || 0],
      get value() {
        return this.val
      },
      set value(value) {
        this.val = value
      },
    },
    {
      title: intl.formatMessage({ id: 'DASHBOARD.PARTICIPATION_RATE' }),
      tooltip: intl.formatMessage({ id: 'DASHBOARD.PARTICIPATION_RATE_TOOLTIP' }),
      chartOptions,
      val: [rate?.participationRate || 0],
      get value() {
        return this.val
      },
      set value(value) {
        this.val = value
      },
    },
  ]

  return (
    <>
      <div className='d-flex justify-content-between gap-5 mt-5'>
        <div className='card p-3 w-100 d-flex flex-column justify-content-between p-10 fs-2'>
          <div className='fs-1 fw-bold text-primary mb-7'>
            {intl.formatMessage({ id: 'ANALYTICS.INSIGHTS_AT_A_GLANCE' })}
          </div>
          <div className='row align-items-center'>
            <div className='col-md-8 d-flex flex-column gap-3'>
              {rate?.analyticsRateDetails.map((rateDetail, index) => {
                return (
                  <div key={index} className='d-flex align-items-center'>
                    <span className='bullet bullet-dot bg-info me-5'></span>
                    {rateDetail}
                  </div>
                )
              })}
              {/* <li className='list-unstyled d-flex align-items-center'>
                <span className='bullet bullet-dot bg-info me-5'></span>
                Peak hours for weekdays are between 5 PM and 6 PM and for weekends between 2 PM and
                4 PM.
              </li>
              <li className='list-unstyled d-flex align-items-center'>
                {' '}
                <span className='bullet bullet-dot bg-info me-5'></span>8 products generate 80% of
                total sales
              </li>
              <li className='list-unstyled d-flex align-items-center'>
                {' '}
                <span className='bullet bullet-dot bg-info me-5'></span>
                Customers make a transaction every 15 days
              </li>
              <li className='list-unstyled d-flex align-items-center'>
                {' '}
                <span className='bullet bullet-dot bg-info me-5'></span>
                20% of customers have made more than one transaction
              </li>
              <li className='list-unstyled d-flex align-items-center'>
                {' '}
                <span className='bullet bullet-dot bg-info me-5'></span>
                Customers prefer to redeem their points on Fridays
              </li> */}
            </div>
            <div className='col-md-4'>
              <div className='row'>
                {chartInfos.map((chartInfo, index) => {
                  return (
                    <div className='col-md-6' key={index}>
                      <div className='text-center fs-1 fw-bold mb-3'>
                        {chartInfo.title}
                        <span className='position-relative'>
                          <OverlayTrigger
                            placement='top'
                            overlay={<Tooltip>{chartInfo.tooltip}</Tooltip>}
                          >
                            <i className='bi bi-info-circle text-primary ms-1'></i>
                          </OverlayTrigger>
                        </span>
                      </div>
                      <RateCircle options={chartInfo.chartOptions} series={chartInfo.val} />
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className='separator my-10'
        style={{
          borderBottom: '2px solid rgba(217, 219, 228, 0.5)',
        }}
      ></div>
    </>
  )
}
